
import React from 'react';
import Header from '../../components/feature/Header';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden pt-16">
        {/* YouTube Video Background */}
        <div className="absolute inset-0 z-0">
          <iframe
            className="absolute top-1/2 left-1/2 w-[300%] h-[300%] md:w-[150%] md:h-[150%] min-w-[300%] min-h-[300%] md:min-w-[150%] md:min-h-[150%] transform -translate-x-1/2 -translate-y-1/2"
            src="https://www.youtube.com/embed/i0c3vi7v9FU?autoplay=1&mute=1&loop=1&playlist=i0c3vi7v9FU&controls=0&showinfo=0&rel=0&modestbranding=1&iv_load_policy=3&disablekb=1"
            title="SHADOW Security Background Video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
          <div className="absolute inset-0 bg-black/50"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 text-center max-w-4xl mx-auto px-4">
          <div className="mb-8">
            <img 
              alt="SHADOW Logo" 
              className="h-24 mx-auto mb-6" 
              src="https://static.readdy.ai/image/7b342ecdc882aff5ee2c0e983bfdb975/9277d26540fc2749982973de63252ceb.png"
            />
          </div>
          
          <h1 className="text-6xl font-bold mb-6 bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">
            SHADOW
          </h1>
          
          <p className="text-2xl mb-4 text-gray-300">Security Contractors</p>
          
          <p className="text-xl mb-8 text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Specialized in Executive Security, Tactical Training, and Advanced AI Surveillance Solutions
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-black font-bold py-4 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer">
              Request Consultation
            </button>
            <a 
              className="border-2 border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black font-bold py-4 px-8 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-center" 
              href="/services"
            >
              View Services
            </a>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
          <div className="animate-bounce">
            <i className="ri-arrow-down-line text-yellow-500 text-2xl"></i>
          </div>
        </div>
      </section>

      {/* Government Certified Section */}
      <section className="py-16 bg-gradient-to-b from-black to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-6 text-white">
              Government <span className="text-yellow-500">Certified</span>
            </h2>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto">
              Officially registered SAM.gov vendor with verified NAICS codes for government contracting
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-6 text-center">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-government-line text-xl text-black"></i>
              </div>
              <h3 className="text-lg font-bold mb-2 text-white">SAM.gov Vendor</h3>
              <p className="text-gray-400 text-sm">Registered Government Contractor</p>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-6 text-center">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-xl text-black"></i>
              </div>
              <h3 className="text-lg font-bold mb-2 text-white">NAICS 561620</h3>
              <p className="text-gray-400 text-sm">Investigation Services</p>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-6 text-center">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-computer-line text-xl text-black"></i>
              </div>
              <h3 className="text-lg font-bold mb-2 text-white">NAICS 541519</h3>
              <p className="text-gray-400 text-sm">Computer Systems Design</p>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-6 text-center">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-radar-line text-xl text-black"></i>
              </div>
              <h3 className="text-lg font-bold mb-2 text-white">NAICS 336992</h3>
              <p className="text-gray-400 text-sm">Military Armored Vehicle Manufacturing</p>
            </div>
          </div>

          <div className="mt-8 text-center">
            <div className="bg-gray-800/30 backdrop-blur-sm border border-gray-700 rounded-xl p-6 inline-block">
              <div className="flex items-center justify-center mb-2">
                <i className="ri-broadcast-line text-yellow-500 text-xl mr-3"></i>
                <h3 className="text-lg font-bold text-white">NAICS 516990</h3>
              </div>
              <p className="text-gray-400 text-sm">All Other Information Services</p>
            </div>
          </div>
        </div>
      </section>

      {/* Primary Security Services Section */}
      <section className="py-20 bg-gradient-to-b from-gray-900 to-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-6 text-white">
              Primary <span className="text-yellow-500">Security Services</span>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Comprehensive tactical training and executive protection services for government and corporate clients
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-8 hover:border-yellow-500/50 transition-all duration-300 transform hover:scale-105">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-shield-user-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-white">Executive Security</h3>
              <p className="text-gray-400 leading-relaxed">
                Premium protection services for high-profile individuals and corporate executives
              </p>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-8 hover:border-yellow-500/50 transition-all duration-300 transform hover:scale-105">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-crosshair-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-white">Tactical Training</h3>
              <p className="text-gray-400 leading-relaxed">
                Operational tactical small units training and marksmanship programs
              </p>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-8 hover:border-yellow-500/50 transition-all duration-300 transform hover:scale-105">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-first-aid-kit-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-white">Combat Medicine</h3>
              <p className="text-gray-400 leading-relaxed">
                TCCC (Tactical Combat Casualty Care) and advanced medical training
              </p>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-8 hover:border-yellow-500/50 transition-all duration-300 transform hover:scale-105">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-search-eye-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-white">Reconnaissance</h3>
              <p className="text-gray-400 leading-relaxed">
                Combat tracking, reconnaissance, and surveillance operations
              </p>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-8 hover:border-yellow-500/50 transition-all duration-300 transform hover:scale-105">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-moon-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-white">NVG Operations</h3>
              <p className="text-gray-400 leading-relaxed">
                Night Vision Goggle employment and low-light tactical operations
              </p>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-xl p-8 hover:border-yellow-500/50 transition-all duration-300 transform hover:scale-105">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-shield-check-line text-2xl text-black"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-white">Force Protection</h3>
              <p className="text-gray-400 leading-relaxed">
                Security risk management, force protection, and antiterrorism services
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* AI Defense & Surveillance Section */}
      <section className="py-20 bg-gradient-to-b from-black to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-6 text-white">
              AI Defense & <span className="text-yellow-500">Surveillance</span>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Cutting-edge AI-powered security solutions with military-grade technology
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-gray-800/30 backdrop-blur-sm border border-gray-700 rounded-xl p-6 hover:border-yellow-500/50 transition-all duration-300 transform hover:scale-105">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-eye-line text-xl text-black"></i>
              </div>
              <h3 className="text-lg font-bold mb-3 text-white">AI-Powered Surveillance</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Advanced AI defense systems with real-time threat detection
              </p>
            </div>

            <div className="bg-gray-800/30 backdrop-blur-sm border border-gray-700 rounded-xl p-6 hover:border-yellow-500/50 transition-all duration-300 transform hover:scale-105">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-lightbulb-line text-xl text-black"></i>
              </div>
              <h3 className="text-lg font-bold mb-3 text-white">Smart Solar Lights</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Military-licensed AI solar street lights with drone capabilities
              </p>
            </div>

            <div className="bg-gray-800/30 backdrop-blur-sm border border-gray-700 rounded-xl p-6 hover:border-yellow-500/50 transition-all duration-300 transform hover:scale-105">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-user-search-line text-xl text-black"></i>
              </div>
              <h3 className="text-lg font-bold mb-3 text-white">Facial Recognition</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Advanced biometric identification and access control systems
              </p>
            </div>

            <div className="bg-gray-800/30 backdrop-blur-sm border border-gray-700 rounded-xl p-6 hover:border-yellow-500/50 transition-all duration-300 transform hover:scale-105">
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-alarm-warning-line text-xl text-black"></i>
              </div>
              <h3 className="text-lg font-bold mb-3 text-white">Gunshot Detection</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Acoustic gunshot detection and rapid response systems
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Military-Licensed AI Technology Section */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold mb-6 text-white">
                Military-Licensed <span className="text-yellow-500">AI Technology</span>
              </h2>
              <p className="text-xl text-gray-400 mb-8 leading-relaxed">
                SHADOW has recently attained military licensing for our revolutionary AI-powered solar street lights with integrated drone capabilities, detection systems, and smart grid integration.
              </p>
              
              <div className="space-y-4">
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-yellow-500 rounded-full mr-4"></div>
                  <span className="text-gray-300">Drone Detection & Response Capabilities</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-yellow-500 rounded-full mr-4"></div>
                  <span className="text-gray-300">Advanced Facial Recognition Systems</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-yellow-500 rounded-full mr-4"></div>
                  <span className="text-gray-300">Acoustic Gunshot Detection</span>
                </div>
                <div className="flex items-center">
                  <div className="w-2 h-2 bg-yellow-500 rounded-full mr-4"></div>
                  <span className="text-gray-300">Smart Grid Integration</span>
                </div>
              </div>
            </div>

            <div className="relative">
              <img 
                alt="AI-Powered Security Technology" 
                className="rounded-xl shadow-2xl w-full object-cover" 
                src="https://static.readdy.ai/image/7b342ecdc882aff5ee2c0e983bfdb975/f44c8ac25f9f1f82b4ec504cb4d7ce21.jpeg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-xl"></div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-gray-900 via-black to-gray-900">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-6 text-white">
            Ready to Secure Your <span className="text-yellow-500">Operations?</span>
          </h2>
          <p className="text-xl text-gray-400 mb-8 max-w-2xl mx-auto">
            Contact SHADOW today for a confidential consultation about your security and training requirements.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-black font-bold py-4 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer">
              Schedule Consultation
            </button>
            <a 
              className="border-2 border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black font-bold py-4 px-8 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-center" 
              href="/contact"
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
